// Stylesheets
import '../styles/home.scss';

// Third party libraries
import React from 'react';

// MUI imports
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { ICON_URL } from '../constants';

const Home = () => {
  return (
    <>
      <div className="splashBackground">
        <Container className="splash">
          <Stack spacing={'10rem'} direction="row">
            <Box sx={{ display: 'flex' }} direction="column" justifyContent="center" alignItems="center">
              <img alt="Logo" src={ICON_URL} />
            </Box>
            <Box className="splashText">
              <Typography className="lineOne" variant="span">
                Welcome to the
              </Typography>
              <Typography className="lineTwo" fontWeight="bold" variant="span">
                South Dakota Natural Resources
              </Typography>
              <Typography className="lineThree" sx={{ fontSize: '3.2rem' }} fontWeight="bold" variant="span">
                Accomplishment Reporting & Planning Hub
              </Typography>
              <div className="divider"></div>
              <Typography className="subtextLine">
                ARP Hub is designed to facilitate collaborative planning by sharing mapped priorities, projects and activity locations, both planned and completed.
              </Typography>
            </Box>
          </Stack>
        </Container>
      </div>
    </>
  );
}

export default Home;
